export default __webpack_public_path__ + "static/media/raycaster.b5dc390e.png";